// extracted by mini-css-extract-plugin
export var bodySections = "_49-8";
export var gray = "_49-7";
export var green = "_49-4";
export var iconContainer = "_49-9";
export var iconWidgetContainer = "_49-1";
export var phoneIcon = "_49-2";
export var red = "_49-5";
export var statusDot = "_49-3";
export var widgetContainer = "_49-0";
export var yellow = "_49-6";